import { Flex, Typography } from '@iheartjane/reefer';
import type { GoogleFontFamily } from '@iheartjane/types';
import { Controller } from 'react-hook-form';

import { FontPicker } from '@jane/business-admin/components/premium/FontPicker';
import { toLabeledFontOption } from '@jane/business-admin/util';

export const FontsSection = ({
  supportedFontFamilies,
}: {
  supportedFontFamilies: GoogleFontFamily[];
}) => {
  return (
    <>
      <Typography>
        Menus use a default font until you select or upload your own brand font.
      </Typography>
      <Flex flexDirection="column" py={24} gap={24}>
        <Flex flexDirection="column" gap={8}>
          <Typography variant="body-bold">Headings</Typography>

          <Controller
            name="fonts.heading"
            render={({ field }) => (
              <FontPicker
                activeFontFamily={toLabeledFontOption(
                  supportedFontFamilies.find(
                    ({ family }) => family === field.value?.family
                  )
                )}
                defaultFontFamily={{
                  label: 'Euclid Circular B',
                  value: 'Euclid Circular B',
                }}
                fontFamilies={supportedFontFamilies}
                label="heading-font"
                onChange={(font) => {
                  field.onChange(font);
                }}
              />
            )}
          />
        </Flex>
        <Flex flexDirection="column" gap={8}>
          <Typography variant="body-bold">Paragraph</Typography>
          <Controller
            name="fonts.body"
            render={({ field }) => (
              <FontPicker
                activeFontFamily={toLabeledFontOption(
                  supportedFontFamilies.find(
                    ({ family }) => family === field.value?.family
                  )
                )}
                defaultFontFamily={{
                  label: 'Source Sans Pro',
                  value: 'Jane Default',
                }}
                fontFamilies={supportedFontFamilies}
                label="body-font"
                onChange={(font) => {
                  field.onChange(font);
                }}
              />
            )}
          />
        </Flex>
      </Flex>
    </>
  );
};
